import React from 'react';

export default function ZaptBadge() {
  return (
    <div className="fixed bottom-4 left-4 z-50">
      <a
        href="https://www.zapt.ai"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-gray-900 hover:bg-gray-800 text-white px-2 py-1 md:px-3 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-colors duration-300 border border-gray-700 hover:border-gray-600 min-h-[36px] flex items-center justify-center"
      >
        Made on ZAPT
      </a>
    </div>
  );
}